import {
  BatteryCharging,
  CarFront,
  CircleGauge,
  Fuel,
  KeyRound,
  ShieldCheck,
  Truck,
  Wrench,
} from 'lucide-react';

export const CONTACT = {
  phoneDisplay: '(604) 398-8866',
  phoneHref: 'tel:+16043988866',
  textHref: 'sms:+16043988866?&body=HELP%20-%20I%20need%20roadside%20assistance.',
  email: 'dispatch@jonnystowingbc.ca',
  area: 'Richmond & Greater Vancouver, BC',
};

export const SERVICES = [
  {
    slug: 'flatbed-towing',
    title: 'Flatbed Towing',
    short: 'Careful transport for cars, SUVs, luxury, lowered and non-running vehicles.',
    icon: Truck,
    experience: 'Peace of mind when your day has been turned upside down.',
  },
  {
    slug: 'local-towing',
    title: 'Local Towing',
    short: 'Dependable local towing throughout Richmond and the Lower Mainland.',
    icon: CarFront,
    experience: 'A clear path forward when your vehicle cannot continue.',
  },
  {
    slug: 'vehicle-recovery',
    title: 'Vehicle Recovery & Winching',
    short: 'Skilled recovery from mud, curbs, ditches, parkades and tight locations.',
    icon: CircleGauge,
    experience: 'A capable rescue with no shame—just care for you and your vehicle.',
  },
  {
    slug: 'lockout-assistance',
    title: 'Lockout Assistance',
    short: 'Professional vehicle entry when keys are locked inside.',
    icon: KeyRound,
    experience: 'Relief and regained control without unnecessary stress.',
  },
  {
    slug: 'jump-starts',
    title: 'Jump Starts',
    short: 'Battery boost service for passenger vehicles and light commercial units.',
    icon: BatteryCharging,
    experience: 'A spark of power and confidence when you feel drained.',
  },
  {
    slug: 'tire-changes',
    title: 'Spare Tire Changes',
    short: 'Safe roadside changeover to your usable spare tire.',
    icon: Wrench,
    experience: 'A smooth transition from panic to back on the road.',
  },
  {
    slug: 'fuel-delivery',
    title: 'Emergency Fuel Delivery',
    short: 'A small emergency fuel supply delivered to help get you moving.',
    icon: Fuel,
    experience: 'A second chance when you thought you were out of options.',
  },
  {
    slug: 'specialty-transport',
    title: 'Specialty Transport',
    short: 'Motorcycles, forklifts, equipment, classics and unusual moves assessed case by case.',
    icon: ShieldCheck,
    experience: 'Confidence that unusual cargo is being handled thoughtfully.',
  },
];

export const REVIEWS = [
  {
    quote: 'Fast, kind and professional. They made a stressful breakdown feel completely manageable.',
    name: 'Richmond customer',
  },
  {
    quote: 'The communication was excellent and my vehicle was handled with real care.',
    name: 'Lower Mainland driver',
  },
  {
    quote: 'A towing company that actually treats people like people. Five-star service from start to finish.',
    name: 'Local customer',
  },
];

export const EVENTS = [
  {
    year: '2025',
    title: "Saint Hallow's Asylum",
    category: 'Halloween Community Event',
    text: "Richmond's haunted attraction brought together elaborate sets, performers and community support for an unforgettable Halloween experience.",
  },
  {
    year: '2024',
    title: "Jonny's Haunted Mansion",
    category: 'Community Fundraiser',
    text: 'Created with support from local businesses and benefitting the Delta Farmland & Wildlife Trust.',
  },
  {
    year: 'October 2019',
    title: "Jonny's Pirate Haven",
    category: 'Halloween Community Installation',
    text: 'A stationary pirate ship built from recycled pallets and repurposed materials, transforming the property into a family Halloween experience.',
  },
];
